<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
  <p *ngIf="data.warningMessage" class="warning-message">{{ data.warningMessage }}</p>
  <p *ngFor="let warning of data.warningMessages" class="warning-message">{{ warning }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <ng-container *ngIf="data.button1 as button1">
    <button
      class="btn-1"
      mat-raised-button
      [mat-dialog-close]="button1.result"
      color="{{ button1.matColor ? button1.matColor : '' }}"
      *ngIf="button1.focusInitial"
      cdkFocusInitial
    >
      <mat-icon *ngIf="button1.icon" fontSet="material-symbols-outlined">{{ button1.icon }}</mat-icon>
      {{ button1.label }}
    </button>
    <button
      class="btn-1"
      mat-raised-button
      [mat-dialog-close]="button1.result"
      color="{{ button1.matColor ? button1.matColor : '' }}"
      *ngIf="!button1.focusInitial"
    >
      <mat-icon *ngIf="button1.icon" fontSet="material-symbols-outlined">{{ button1.icon }}</mat-icon>
      {{ button1.label }}
    </button>
  </ng-container>
  <ng-container *ngIf="data.button2 as button2">
    <button
      class="btn-2"
      mat-raised-button
      [mat-dialog-close]="button2.result"
      color="{{ button2.matColor ? button2.matColor : '' }}"
      *ngIf="button2.focusInitial"
      cdkFocusInitial
    >
      <mat-icon *ngIf="button2.icon" fontSet="material-symbols-outlined">{{ button2.icon }}</mat-icon>
      {{ button2.label }}
    </button>
    <button
      class="btn-2"
      mat-raised-button
      [mat-dialog-close]="button2.result"
      color="{{ button2.matColor ? button2.matColor : '' }}"
      *ngIf="!button2.focusInitial"
    >
      <mat-icon *ngIf="button2.icon" fontSet="material-symbols-outlined">{{ button2.icon }}</mat-icon>
      {{ button2.label }}
    </button>
  </ng-container>
</mat-dialog-actions>
